module.exports = __webpack_public_path__ + "img/INTERIOR-SWIFT-2021-2.750d0792.jpg";